<template>
  <b-modal
    hide-footer
    size="xl"
    title="Crawling Line & Total Features"
    centered
    id="crawling-line-total"
    @shown="handleGetListSport"
  >
    <div class="text-black pt-2 pb-2">
      <b-row>
        <!-- LIST SPORT -->
        <b-col cols="12" lg="4" style="border-right: 1px solid #dae1e7">
          <div
            v-for="(sport, index) in listSports"
            :key="sport.id"
            class="d-flex align-items-center justify-content-between p-1"
            :class="{
              'border-bot': index !== listSports.length - 1,
              'active-item': selectedSport && selectedSport.id === sport.id,
            }"
            style="cursor: pointer; gap: 16px"
            @click="handleSelectSport(sport)"
          >
            <div>
              {{ sport.name }}
            </div>
          </div>
        </b-col>
        <!-- GROUPS -->
        <b-col
          v-if="selectedSport"
          cols="12"
          lg="8"
          style="border-right: 1px solid #dae1e7"
        >
          <div
            class="d-flex justify-content-between mb-1"
            :style="{
              borderBottom: groups.length === 0 ? '1px solid #dae1e7' : 'none',
              paddingBottom: groups.length === 0 ? '5px' : '0',
            }"
          >
            <h5>MARKET TYPES</h5>
            <b-button
              variant="primary"
              style="padding: 6px 10px; font-size: 12px"
              @click="handleShowModalAddNewMarketName"
              >Add new market type</b-button
            >
          </div>

          <div
            v-if="groups.length > 0"
            class="d-flex align-items-center justify-content-between mb-1"
          >
            <p class="text-muted m-0">
              <feather-icon icon="MoveIcon" class="mr-1" />
              Drag to reorder display priority
            </p>
            <b-button
              variant="primary"
              size="sm"
              @click="handleSaveOrder"
              style="padding: 6px 10px; font-size: 12px"
              class="ml-1"
            >
              <feather-icon icon="SaveIcon" />
              Save order
            </b-button>
          </div>
          <draggable
            v-if="groups.length > 0"
            :list="groups"
            :group="{ name: 'groups' }"
            :sort="true"
          >
            <div
              v-for="(group, index) in groups"
              :key="group.id"
              class="d-flex align-items-center justify-content-between p-1"
              :class="{
                'border-bot': index !== groups.length - 1,
                'active-item': selectedGroup && selectedGroup.id === group.id,
              }"
              style="cursor: pointer; gap: 16px"
              @click="selectGroup(group)"
            >
              <div>
                <feather-icon icon="AlignCenterIcon" class="text-muted mr-1" />
                <b-badge
                  class="text-capitalize mr-1"
                  :variant="group.type === 'line' ? 'success' : 'warning'"
                >
                  {{ group.type }}
                </b-badge>
                {{ group.name }}
              </div>
              <div v-if="!!group.name">
                <feather-icon
                  size="18"
                  icon="TrashIcon"
                  class="text-danger cursor-pointer"
                  @click="showModal('delete-group', group)"
                />
                <feather-icon
                  size="18"
                  icon="EditIcon"
                  class="ml-1 text-warning cursor-pointer"
                  @click="handleEditMarketName(group)"
                />
              </div>
            </div>
          </draggable>
        </b-col>
      </b-row>

      <!-- MODAL ADD/UPDATE GROUP -->
      <b-modal
        ref="add-group"
        title="Market Type"
        centered
        cancel-variant="outline-secondary"
        hide-footer
        no-close-on-backdrop
        @hide="hideModalSetting"
      >
        <div v-if="modalType === 'add'" class="text-black d-flex">
          <p class="mb-1 mr-2">Type</p>
          <b-form-radio-group
            id="type"
            v-model="type"
            :options="optionsType"
            name="type"
          />
        </div>

        <div style="color: black" class="mb-2">
          <p class="m-0" style="padding-bottom: 5px">Market Type Name</p>
          <v-select
            v-model="newMarketName"
            :options="marketTypeOptions"
            :loading="loadingMarketTypes"
            label="marketType"
            :reduce="(opt) => opt.marketType"
            :filterable="false"
            placeholder="Select market type..."
            @search="onSearchMarketType"
          />
        </div>
        <b-row>
          <b-col class="d-flex justify-content-end mt-2">
            <b-button
              v-if="modalType === 'add'"
              variant="primary"
              class="mb-1 mb-sm-0"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              @click="handleSaveNewMarketName"
            >
              <Spinner v-if="isLoading" />
              <template v-else> Save </template>
            </b-button>
            <b-button
              v-if="modalType === 'edit'"
              variant="primary"
              class="mb-1 mb-sm-0"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              @click="handleSaveUpdateGroup"
            >
              <Spinner v-if="isLoading" />
              <template v-else> Save </template>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <!-- MODAL CONFIRM -->
      <b-modal
        ref="modal"
        :title="modal.title"
        centered
        cancel-variant="outline-secondary"
        :ok-disabled="isLoading"
        @ok="handleSubmitModal"
      >
        <b-card-text style="color: black">
          {{ modal.content }}
        </b-card-text>
        <template #modal-ok>
          <Spinner v-if="isLoading" />
          <span v-else>Submit</span>
        </template>
      </b-modal>
    </div>
  </b-modal>
</template>

<script>
import useToastHandler from "@/services/toastHandler";
import {
  BCol,
  BRow,
  BButton,
  BIcon,
  BFormCheckbox,
  BFormInput,
  BCardText,
  BBadge,
  BFormRadioGroup,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import { debounce } from "debounce";
import draggable from "vuedraggable";
import Spinner from "@/@core/components/Spinner.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BIcon,
    BFormCheckbox,
    draggable,
    BFormInput,
    BCardText,
    Spinner,
    vSelect,
    BBadge,
    BFormRadioGroup,
  },
  data() {
    return {
      groups: [],
      selectedGroup: null,
      checkActiveSport: true,
      modal: {
        title: "",
        content: "",
      },
      action: {
        type: "",
        id: "",
      },
      modalTitle: "",
      newMarketName: "",
      modalType: "",
      listSports: [],
      selectedSport: null,
      optionsType: [
        { text: "Line", value: "line" },
        { text: "Total", value: "total" },
      ],
      type: "line",
      editItem: null,
      marketTypeOptions: [],
      loadingMarketTypes: false,
    };
  },
  watch: {
    selectedSport(newVal) {
      if (newVal) {
        this.fetchMarketList();
      }
    },
  },
  computed: {
    ...mapState("sport/market", [
      "loadingDelete",
      "loadingUpdateKey",
      "loadingUpdateOrder",
      "loadingCreateGroup",
    ]),
    isLoading() {
      return (
        this.loadingDelete || this.loadingUpdateKey || this.loadingCreateGroup
      );
    },
  },
  methods: {
    ...mapActions({
      getListSport: "sport/list/getListSport",
      createMarketMappingH2H: "sport/market/createMarketMappingH2H",
      updateMappingH2HMarket: "sport/market/updateMappingH2HMarket",
      deleteCrawlingH2HMarket: "sport/market/deleteCrawlingH2HMarket",
      updateOrderNumberListMappingH2H:
        "sport/market/updateOrderNumberListMappingH2H",
      getListMappingH2H: "sport/market/getListMappingH2H",
      getMarketTypeDropdown: "sport/crawling-market/getMarketTypeDropdown",
    }),
    async handleGetListSport() {
      const { data } = await this.getListSport({
        page: 1,
        limit: 100,
        source: "sporting",
      });
      if (Array.isArray(data)) {
        this.listSports = data;
        this.selectedSport = this.listSports[0];
        await this.fetchMarketTypeOptions("");
      }
    },
    async fetchMarketList() {
      const data = await this.getListMappingH2H({
        page: 1,
        limit: 100,
        sportId: this.selectedSport.id,
      });
      if (Array.isArray(data.data)) {
        this.groups = data.data;
      }
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };

      if (type === "delete-group") {
        this.setModal(
          "Delete Market Type",
          `Are you sure you want to delete market type ${item.name}?`
        );
      }
      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { type, item } = this.action;
      if (type === "delete-group") await this.handleDeleteMarketName(item);

      if (!this.isLoading) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleDeleteMarketName(item) {
      const res = await this.deleteCrawlingH2HMarket(item.id);
      if (res) {
        this.showToastSuccess("Success", "Market deleted successfully!");
        await this.handleReload();
      }
    },
    async handleReload() {
      await this.fetchMarketList();
    },
    async handleSaveNewMarketName(event) {
      event.preventDefault();
      if (!this.newMarketName)
        return this.showToastError(false, "Please enter market type");
      const res = await this.createMarketMappingH2H({
        sportId: this.selectedSport.id,
        Name: this.newMarketName,
        source: "sporting",
        type: this.type,
      });
      if (res) {
        this.showToastSuccess("Success", "Add new market type successfully!");
        this.$refs["add-group"].hide();
        this.handleReload();
      }
    },
    async handleSaveUpdateGroup(event) {
      event.preventDefault();
      if (!this.newMarketName)
        return this.showToastError(false, "Please enter group information");
      const res = await this.updateMappingH2HMarket({
        id: this.editItem.id,
        Name: this.newMarketName,
        source: "sporting",
      });
      if (res) {
        this.showToastSuccess("Success", "Updated market type successfully!");
        this.$refs["add-group"].hide();
        this.handleReload();
      }
    },
    async handleSaveOrder() {
      const listLine = this.groups
        .filter((i) => i.type === "line")
        .map((l, ind) => {
          return {
            id: l.id,
            settingOrderNumber: 1000 + ind + 1,
          };
        });
      const listTotal = this.groups
        .filter((i) => i.type === "total")
        .map((t, ind) => {
          return {
            id: t.id,
            settingOrderNumber: 10000 + ind + 1,
          };
        });
      const res = await this.updateOrderNumberListMappingH2H({
        markets: [...listLine, ...listTotal],
      });
      if (res) {
        this.showToastSuccess("Success", "Updated market order successfully!");
        this.handleReload();
      }
    },
    handleEditMarketName(item) {
      this.modalType = "edit";
      this.newMarketName = item.name;
      this.editItem = item;
      this.$refs["add-group"].show();
      this.fetchMarketTypeOptions("");
    },
    async fetchMarketTypeOptions(search) {
      if (!this.selectedSport) return;
      const sportCode = this.selectedSport.code || this.selectedSport.name;
      const data = await this.getMarketTypeDropdown({
        sportCode,
        ...(search && { search }),
      });
      this.marketTypeOptions = Array.isArray(data) ? data : [];
    },
    hideModalSetting() {
      this.newMarketName = "";
      this.marketTypeOptions = [];
    },
    handleShowModalAddNewMarketName() {
      this.newMarketName = "";
      this.marketTypeOptions = [];
      this.modalType = "add";
      this.$refs["add-group"].show();
      this.fetchMarketTypeOptions("");
    },
    handleSelectSport(sport) {
      this.selectedSport = sport;
      this.fetchMarketTypeOptions("");
    },
    onSearchMarketType: debounce(function (search) {
      if (!this.selectedSport) return;
      this.fetchMarketTypeOptions(search);
    }, 300),
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss" scoped>
.border-bot {
  border-bottom: 1px solid #dae1e7;
}

.active-item {
  color: #0d6efd;
  font-weight: bold;
  border-left: 2px solid #0d6efd;
  background: #e7f1ff;
}

.market-outline {
  padding: 20px;
  border: 1px solid #dae1e7;
  border-radius: 10px;
}
</style>
